import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { ModelYhcOffices } from './yhcDataTypes'

type YhcOfficeRecord = ModelYhcOffices & { id?: number }

/**
 * 事業所マスタ
 * - 配送センター、本社の各部署含めた全事業所
 * - 郵便番号マスタの「家財担当店」コードと紐づく
 */
export const yhc_offices: ModelDef<YhcOfficeRecord> = {
  tableName: 'yhc_offices',
  tableLabel: '事業所マスタ',
  tableComment: '配送センター、本社の各部署含めた全事業所マスタ',
  primaryKeyColType: 'NUMBER',
  columns: {
    code: {
      type: 'STRING',
      label: 'コード',
      unique: true,
      editable: false,
      editableOnCreate: true,
      bulkEditable: false,
      replicable: true,
      inputHelpText: '6桁のコード。郵便番号マスタの"家財担当店" に該当',
    },
    name: {
      type: 'STRING',
      label: '名称',
      replicable: true,
    },
    zip: {
      type: 'STRING',
      label: '郵便番号',
      validate: { len: [7, 7] },
      inputAttrs: {
        prefix: '〒',
        wrapperStyle: {
          maxWidth: '130px',
          minWidth: '130px',
        },
      },
    },
    prefecture: {
      type: 'STRING',
      label: '都道府県',
      inputAttrs: {
        wrapperStyle: {
          maxWidth: '150px',
          minWidth: '150px',
        },
      },
    },
    address1: {
      type: 'STRING',
      label: '住所1',
      width: { xs: 48 },
    },
    address2: {
      type: 'STRING',
      label: '住所2',
      width: { xs: 48 },
    },
    tel1: {
      type: 'STRING',
      label: '電話番号1',
    },
    tel2: {
      type: 'STRING',
      label: '電話番号2',
    },
  },
}
